import { Injectable } from '@angular/core';
import {DatePipe} from "@angular/common";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {EnvironmentService} from "../../environment/environment.service";
import {AuthService} from "../../auth/auth.service";
import CompanyEventDate from "../../interfaces/company-event-date";
import CompanyEventAttendee from "../../interfaces/company-event-attendee";
import {DateTimeService} from "../../services/date-time.service";
import CompanyEventAddress from "../../interfaces/company-event-address";

@Injectable({
  providedIn: 'root'
})
export class CompanyEventsListManagerService {

  constructor(private datePipe: DatePipe, private dateTime: DateTimeService, private env: EnvironmentService, private http: HttpClient, private auth: AuthService) {
    let keys = this.typesList();
    for(let i = 0; i < keys.length; i++){
      this.companyEventTypes[keys[i]].display = 'block';
      this.companyEventTypes[keys[i]].groupId = i.toString();
      this.companyEventTypes[keys[i]].checked = true;
      this.companyEventTypes[keys[i]].groupColor = this.companyEventTypes[keys[i]].color;
    }
  }

  public listEvents:any[] = []

  public companyEventTypes: { [key: string]: any } = {
    'CREAFoundation': {
      color: 'var(--purple-3)',
      label: 'CREAFoundation',
    },
    'Internal CREA Event': {
      color: 'var(--medium-blue-3)',
      label: 'Internal CREA Event',
    },
    'Property Event': {
      color: 'var(--teal-2)',
      label: 'Property Event',
    },
    'Conference': {
      color: 'var(--amber-4)',
      label: 'Conference',
    },
    'Special Event': {
      color: 'var(--orange-3)',
      label: 'Special Event',
    },
    'Non-attended Event': {
      color: 'var(--cool-gray-5)',
      label: 'Non-attended Event'
    }
  }

  getColorClass(key: string): string {
    let color = this.companyEventTypes[key].color;
    return (
      'checkbox-' + color.substring(color.indexOf('-') + 2, color.indexOf(')'))
    );
  }

  public typesList(): string[] {
    return Object.keys(this.companyEventTypes);
  }

  toggleEventDisplay(key: string): string {
    if (this.companyEventTypes[key].display === 'none') {
      this.companyEventTypes[key].display = 'block';
      this.companyEventTypes[key].checked = true;
    } else {
      this.companyEventTypes[key].display = 'none';
      this.companyEventTypes[key].checked = false;
    }
    return this.companyEventTypes[key].display;
  }

  fetchTypeDisplays(){
    let types = this.typesList();
    let displays:any = []
    types.forEach((type) => {
      let displayObj = {key: type, display: this.companyEventTypes[type].display}
      displays.push(displayObj)
    })
    return displays;
  }

  public getDates(){
    let start = new Date();
    let end = new Date(start.getFullYear()+1, start.getMonth(), start.getDate());
    return {start: start, end: end}
  }

  public formatCompanyListForExport(events: CompanyEventDate[]){

    let body:any = {}
    let exports:any[]  = []
    let headers = ["Name", "Dates", "Location", "Is CREA Sponsored?", "Sponsored Amount", "Registered Attendees", "Unregistered Attendees", "Links"]
    const indexName:number = headers.indexOf("Name")
    const indexDate:number = headers.indexOf("Dates")
    const indexLocation: number = headers.indexOf("Location")
    const indexLink: number = headers.indexOf("Links")
    const indexSponsorship: number = headers.indexOf("Is CREA Sponsored?")
    const indexAmount:number = headers.indexOf("Sponsored Amount")
    const indexUnregistered: number = headers.indexOf("Unregistered Attendees")
    const indexRegistered: number = headers.indexOf("Registered Attendees")

    const formatDateInternal = (date: CompanyEventDate) => {
      let val = this.dateTime.formatCompanyEventTimes(date)
      let dateString = this.datePipe.transform(val.startDate + 'T00:00:00', 'MM/dd/yyyy')
      let timeString = ""
      if(val.viewStart){
        timeString = this.datePipe.transform(val.startDate + " " + val.viewStart, "shortTime") ?? ""
      }
      if(val.viewEnd){
        timeString = timeString + " - " + this.datePipe.transform(val.startDate + " " + val.viewEnd, "shortTime")
      }
      if(val.endDate && dateString !== this.datePipe.transform(val.endDate + "T00:00:00", 'MM/dd/yyyy')){
        dateString = dateString + " - " + this.datePipe.transform(val.endDate + "T00:00:00", 'MM/dd/yyyy')
      }
      if(timeString.length){
        let timezoneAbbv = this.dateTime.timezones.find((zone:any) => zone.tz === val.timezone)
        timeString = timeString + " " + timezoneAbbv?.abbr
      }
      return dateString
    }
    const responseToUrl = (webAddresses:any) => {
      let url = ""
      for(let i = 0; i < webAddresses.length; i++){
        let parsedLink = webAddresses[i].webAddress
        let protocol = parsedLink.protocol
        let subdomain = parsedLink.subdomain
        let domain = parsedLink.domain
        let tld = parsedLink.tld
        let path = parsedLink.path
        let parameters = parsedLink.parameters
        let resolveUrl:string;
        resolveUrl = protocol==1 ? 'https' : 'http';
        resolveUrl += "://";
        resolveUrl += subdomain ? subdomain + "." : "";
        resolveUrl += domain ? domain + "." : "";
        resolveUrl += tld ? tld : "";
        resolveUrl += path ? path : "";
        resolveUrl += parameters ? parameters : "";
        url += `=HYPERLINK("${resolveUrl}")`
      }
      return url
    }

    const formatLocations = (addresses: CompanyEventAddress[]) => {
      let addressString = ""
      for(let i = 0; i < addresses.length; i++){
        const address = addresses[i].address
        const zipCode = address.zipCode
        addressString = address.address1 ?? ""
        if(address.address2){
          addressString = addressString + " " + address.address2
        }
        addressString = addressString + ", " + zipCode.city + ", " + zipCode.state.abbreviation + " " + zipCode.zipcode
        if(i!==0){
          addressString = addressString + ", "
        }
      }
      return addressString
    }


    for(let event of events){
      let eventArr:any[] = []
      let title:string = event.companyEvent.title
      let formatDates:any = formatDateInternal(event)
      let formatLocation:string = formatLocations(event.companyEvent.companyEventAddresses)
      let sponsored: boolean = event.companyEvent.is_sponsored
      let sponsorshipAmount: number | string = event.companyEvent.sponsorship_amount ? event.companyEvent.sponsorship_amount : 'N/A'
      let registered: string[] = event.companyEvent.companyEventAttendees.filter((attendee: CompanyEventAttendee) => attendee.is_registered).
        map((attendee:CompanyEventAttendee) => attendee.person.name)
      let unregistered: string[] = event.companyEvent.companyEventAttendees.filter((attendee: CompanyEventAttendee) => !attendee.is_registered).
        map((attendee:CompanyEventAttendee) => attendee.person.name)
      let external = responseToUrl(event.companyEvent.companyEventWebAddresses)

      eventArr.splice(indexName, 0, title)
      eventArr.splice(indexDate, 0, formatDates)
      eventArr.splice(indexLocation, 0, formatLocation)
      eventArr.splice(indexLink, 0, external)
      eventArr.splice(indexSponsorship, 0, sponsored ? 'Yes' : 'No')
      eventArr.splice(indexAmount, 0, sponsorshipAmount)
      eventArr.splice(indexRegistered, 0, registered.length > 1 ? registered.join(', ') : registered[0])
      eventArr.splice(indexUnregistered, 0, unregistered.length > 1 ? unregistered.join(', ') : unregistered[0])
      exports.push(eventArr)

    }
    body["headers"] = headers
    body["export"] = JSON.stringify(exports)
    return body
  }

  public exportCompanyEventList(body:any){
    return new Promise<void>((resolve,reject) => {
      let url = this.env.api_url + "/" + 'excel_export/export'
      const headers = new HttpHeaders({"Authorization": this.auth.getToken()})
      let sub = this.http.post(url, body, {
        responseType: 'blob',
        headers
      }).subscribe((response: Blob) => {
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(response);
        downloadLink.setAttribute('export', 'export.xlsx');
        downloadLink.setAttribute('target', '_blank');
        document.body.appendChild(downloadLink);
        downloadLink.click();
        resolve();
        sub?.unsubscribe();
      });
    })
  }

  public exportCompanyEventListOld(body:any){
    return new Promise<void>((resolve,reject) => {
      let url = this.env.api_url + "/" + 'excel_export/export'
      const headers = new HttpHeaders({"Authorization": this.auth.getToken()})
      let sub = this.http.post(url, body, {
        headers
      }).subscribe((response: any) => {
        let base64Data: string = response.data
        var url = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + base64Data
        var link = document.createElement('a')
        link.href = url;
        window.document.body.append(link)
        link.click()
        window.document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        resolve();
        sub?.unsubscribe();
      });
    })
  }


}
